import React, { createContext, FC, useContext, useMemo } from 'react';
import { trimTrailingCharacter } from 'lib/trimTrailingCharacter';

export type ModuleContext = {
  rootUrl: string;
};

export const ModuleContext = createContext<ModuleContext>({ rootUrl: '' });
export const useModuleContext = () => useContext(ModuleContext);

export const ModuleContextProvider: FC<{ ctx: ModuleContext }> = ({
  ctx,
  children,
}) => {
  const sanitizedCtx = useMemo(() => {
    return {
      ...ctx,
      rootUrl: trimTrailingCharacter('/', ctx.rootUrl),
    };
  }, [ctx]);

  return (
    <ModuleContext.Provider value={sanitizedCtx}>
      {children}
    </ModuleContext.Provider>
  );
};
